export const defaultFlags = {
  "page-builder-canvas-ai-writer": false,
  "page-builder-hide-enter-event-banner": false,
  "page-builder-synced-widget": false,
  "page-builder-hide-deprecated": false,
  "page-builder-deprecated-block-status": "none",
  "event-series": false,
  "content-hub-show-unsaved-changes-label": false,
  "content-hub-direct-video-sharing": false,
  "custom-domains-v-3": false,
  "content-hub-linked-event-promotion": false,
  // TODO: remove this flag https://jira.ringcentral.com/browse/EVE-11873
  "page-builder-manual-order-widgets-deprecation-date":
    "2024-07-01T00:00:00.0000",
  "canvas-enable-edr-tracking": false,
  "post-event-enable-playback-speed": false,
  "pre-event-organization-spaces": false,
};
